// extracted by mini-css-extract-plugin
export default {"wrapper":"dRl3k","content":"IltmG","heading":"aRidT"};